import { useQuery } from '@tanstack/react-query';
import { ApiService } from '@/_services/api.service';
import { queryKeys } from './queryKeys';

/**
 * Query hook to fetch a single conversation by ID
 * Used to get conversation metadata (title, timestamps, etc.)
 */
export const useConversationQuery = (id: string | null) => {
	return useQuery({
		queryKey: queryKeys.conversations.detail(id!),
		queryFn: async () => {
			const { data, error } = await ApiService.GetConversationById(id!);
			if (error || !data) {
				throw new Error(error?.message || 'Failed to fetch conversation');
			}
			return data;
		},
		enabled: !!id
	});
};
